<template>
  <UkiModal :modalId="modalId" :title="title" @close="$emit('close')" @ok="$emit('ok')">
    <div class="form-group">
      <label for="entry-event-type-name">Событие</label>
      <span id="entry-event-type-name">{{entryEventTypeName}}</span>
    </div>
    <div class="form-group">
      <label for="entry-description">Описание</label>
      <textarea id="entry-description" rows="4" :value="entryDescription" @input="$emit('update:entryDescription', $event.target.value)" required/>
    </div>
    <div class="form-group">
      <label for="entry-comment">Комментарий</label>
      <textarea id="entry-comment" rows="4" :value="entryComment" @input="$emit('update:entryComment', $event.target.value)" />
    </div>
  </UkiModal>
</template>

<script>
import UkiModal from "@/components/UkiModal";

export default {
  name: "EditJournalEntryModal",
  components: {UkiModal},
  props: ["modalId", "entryId", "entryEventTypeName", "entryDescription", "entryComment"],
  emits: ["close", "ok", "update:entryDescription", "update:entryComment"],
  computed: {
    title: function(){
      if (this.entryId){
        return "Редактирование записи"
      }

      return this.entryEventTypeName
    }
  }
}
</script>

<style scoped>

</style>